import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DefaultImage from "../../Assets/Images/SideBarLogo.png";
import { useDispatch, useSelector } from "react-redux";
import { addRevista } from "../../Redux/Actions/revistaAShActions";

const AddRevista = () => {
  const navigate = useNavigate();
  const loggedUser = useSelector((state) => state.users.loggedUser);
  const isLoggedIn = Object.keys(loggedUser).length > 0;
  const [title, setTitle] = useState("");
  const [year, setYear] = useState("");
  const [image, setImage] = useState(null);
  const [imageName, setImageName] = useState(null);
  const [imagePreview, setImagePreview] = useState(DefaultImage);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const [newId, setNewId] = useState(null);

  if (!isLoggedIn) {
    navigate("/login");
  }

  const validateForm = () => {
    const errors = {};

    if (!title.trim()) errors.title = "Titulli nuk mund të jetë bosh!";
    if (!year.trim()) {
      errors.year = "Viti nuk mund të jetë bosh!";
    }
    if (!imageName) errors.image = "Kopertina nuk mund të jetë bosh!";

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const uploadImage = (e) => {
    const file = e.target.files[0];
    setImageName(file.name);

    if (file) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleCancel = () => {
    navigate("/manage/revista");
  };

  const getLatestId = async () => {
    try {
      const response = await axios.get(
        "https://api.arkiva.gov.al/api/revista/count",
      );
      return response.data.latestId + 1;
    } catch (error) {
      console.error("Error fetching latest ID:", error);
      return null;
    }
  };

  useEffect(() => {
    const fetchLatestId = async () => {
      const newId = await getLatestId();
      setNewId(newId);
    };
    fetchLatestId();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const revistaData = {
      title,
      year,
      id: newId,
      image: image.name,
    };

    try {
      const response = await axios.post(
        "https://api.arkiva.gov.al/api/revista/create",
        revistaData,
      );

      dispatch(addRevista(response.data));
      const formData = new FormData();

      formData.append("image", image);

      const resp = await axios.post(
        "https://api.arkiva.gov.al/api/revista/uploadFiles",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },

          params: {
            folderId: newId,
          },
        },
      );

      navigate("/manage/revista");
    } catch (err) {
      console.error("Error adding revista:", err);
    }
  };

  return (
    <div className="edit-page">
      <div className="return">
        <button onClick={handleCancel}>
          <i className="fa-solid fa-chevron-left"></i>
        </button>
      </div>
      <p>Shto Revistë</p>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="title">Titulli</label>
          <input
            type="text"
            id="title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          {errors.title && <small className="error">{errors.title}</small>}
        </div>

        <div className="form-group">
          <label htmlFor="year">Viti</label>
          <input
            type="text"
            id="year"
            value={year}
            onChange={(e) => setYear(e.target.value)}
          />
          {errors.year && <small className="error">{errors.year}</small>}
        </div>

        <div className="form-group">
          <label>Kopertina</label>
          <div className="image-wrapper">
            <img
              src={imagePreview}
              alt="preview"
              style={{ width: "120px", height: "120px", objectFit: "cover" }}
            />
          </div>
          <input type="file" accept="image/*" onChange={uploadImage} />
          {errors.image && <small className="error">{errors.image}</small>}
        </div>

        <div className="edit-actions">
          <button type="submit" className="save">
            Shto Revistë
          </button>
          <button type="button" className="cancel" onClick={handleCancel}>
            ANullo
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddRevista;
